<template>
  <div id="createAudio" class="page white" refs="createAudio">
    <el-container class="content-aside">
      <!-- Left Side -->
      <el-main class="cpl-main">
        <!-- Options -->
        <el-row class="options" :gutter="20"></el-row>

        <el-row id="projecPlaylistHeader" :gutter="20">
          <div class="current-audio-preview">
            <div class="active-audio-preview">
              <template v-if="headerAudioPreview && headerAudioPreview._edit">
                <!-- For Not IE Browsers (IMAGE)-->
                <img v-if="headerAudioPreview._edit.preview.hasOwnProperty('type') && headerAudioPreview._edit.preview.type === 'img' && $utils.getBrowser() !== 'IE'"
                  :src="$utils.filterMediaPreviewUrl(headerAudioPreview._edit.preview.url)"
                  class="object-fit_cover_center"/>
                <!-- For IE Browsers (IMAGE)-->
                <div v-if="headerAudioPreview._edit.preview.hasOwnProperty('type') && headerAudioPreview._edit.preview.type === 'img' && $utils.getBrowser() === 'IE'"
                  class="object-fit_fix_on_ie"
                  :style="{'backgroundImage': `url(${headerAudioPreview._edit.preview.url})`}">
                </div>

                <!-- Project Preview -->
                <template v-if="headerAudioPreview._edit.preview.type && headerAudioPreview._edit.preview.type === 'svg'">
                  <iframe :id="`selectedAudioPreview`"
                    :src="$utils.filterMediaPreviewUrl(headerAudioPreview._edit.preview.url)"
                    :data-src="$utils.trimDataSrc(headerAudioPreview._edit.preview.url)"
                    :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${headerAudioPreview._edit.uid}`]">
                  </iframe>
                </template>
              </template>

              <!-- No Preview -->
              <template v-else>
                <div class="no-preview">
                  <div class="np-content">
                    <el-icon class="icon"><PictureFilled /></el-icon>
                    {{$t('label.previewUnavailable')}}
                  </div>
                </div>
              </template>

              <div class="active-audio-preview-cover"></div>
            </div>
          </div>
          <div id="playlistControlWrapper">
            <audio-player v-if="projectAudioPlaylist.data && projectAudioPlaylist.data.audio"
              :updateAudioPlayerProp="updateAudioPlayer"
              :playlistProp="projectAudioPlaylist.data.audio"
              :parentComponentItemSelectionProp="selectedMediaRowUIDs"
              :autoPlayWhenAudioPlayerDataChangedProp="false"
              @audio-player-change="handleAudioPlayerChange($event)">
            </audio-player>
          </div>
        </el-row>

        <div :gutter="20" :class="['main-content-row audio-content-row hide-scrollbar']">
          <div class="audio-list-content">
            <template v-if="projectAudioPlaylist.data && projectAudioPlaylist.data.audio">
              <draggable
                v-bind="sortDraggableOptions"
                v-model="projectAudioPlaylist.data.audio"
                id="audioSortGroup"
                tag="span"
                :disabled="projectFrameStatus !== projectFrameStatusOptions.EDIT_FRAME"
                :class="[{'audio-sortable-group': true, 'disabled': false}]"
                :item-key="(item) => item?._edit?.sortKeyWithIndx"
                :component-data="{name:'flip-list'}"
                :forceFallback="true"
                @start="handleAudioItemSortStart"
                @end="handleAudioItemSortEnd">

                <template #item="{ element: item, index: indx }">
                  <div
                    :class="['audio-row-item', 'sortable-el', 'list-group-item', {
                    'is-row-selected': (item._edit.isRowSelected),
                    'is-sort-drag': audioItemSortDragTriggered,
                    'playing':(projectFrameStatus === projectFrameStatusOptions.PLAY_FRAME) && (projectPreview.isPlaying && projectPreview.currentSong.uid === item.uid),
                    'pause': (projectFrameStatus === projectFrameStatusOptions.PLAY_FRAME) && (!projectPreview.isPlaying && projectPreview.currentSong.uid === item.uid),
                    'mouse-over': (item._edit.mouseEvent && item._edit.mouseEvent === 'mouseover'),
                    'mouse-out': (item._edit.mouseEvent && item._edit.mouseEvent === 'mouseout')}]"
                    @mouseover="handleRowItemMouseHoverAndMouseOut('mouseover', item, $event)"
                    @mouseout="handleRowItemMouseHoverAndMouseOut('mouseout', item, $event)">

                    <!--Media Details -->
                    <div class="media-details">
                      <div class="media-preview-wrapper">
                        <div class="media-preview">
                          <template v-if="!item.status">
                            <div :class="['icons', {'audio-player-controls': (item._edit.isRowSelected)}]">
                              <template v-if="item._edit.isRowSelected">
                                <el-button v-if="(projectPreview.isPlaying && projectPreview.currentSong.uid === item.uid)" class="cstm-icon-btn-medium pause_white_bacgkround"
                                  @click="handleMediaRowClick(mediaRowActions.pauseAudioPreview, item, indx, $event)">
                                </el-button>

                                <el-button v-if="(projectPreview.currentSong.uid !== item.uid) || (projectPreview.currentSong.uid === item.uid && !projectPreview.isPlaying)"
                                  class="cstm-icon-btn-medium play_white_bacgkround"
                                  @click="handleMediaRowClick(mediaRowActions.playAudioPreview, item, indx, $event)">
                                </el-button>
                              </template>
                              <template v-else>
                                <el-button v-if="(projectPreview.isPlaying && projectPreview.currentSong.uid === item.uid)" class="cstm-icon-btn-medium pause_white_bacgkround"
                                  @click="handleMediaRowClick(mediaRowActions.pauseAudioPreview, item, indx, $event)">
                                </el-button>

                                <el-button v-if="(projectPreview.currentSong.uid !== item.uid) || (projectPreview.currentSong.uid === item.uid && !projectPreview.isPlaying)"
                                  class="cstm-icon-btn-medium audio_note_white_bacgkround"
                                  @click="handleMediaRowClick(mediaRowActions.playAudioPreview, item, indx, $event)">
                                </el-button>
                              </template>
                            </div>
                          </template>
                          <template v-else-if="item.preview && item.preview.status">
                            <!-- Project Preview -->
                            <iframe :id="`mediaProjectFile_${item.resourceId}`"
                              :src="$utils.filterMediaPreviewUrl(item.preview.url)"
                              :data-src="$utils.trimDataSrc(item.preview.url)"
                              :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'audio-status-frame', 'media-project-file', `media-preview-${item._edit.uid}`]">
                            </iframe>
                          </template>
                        </div>
                        <div :style="{'backgroundColor': item._edit.backgroundColor}" class="media-preview-background"></div>
                      </div>
                      <div class="media-name">
                        <template v-if="item.metadata && (item.metadata.title || item.metadata.artist)">
                          <div v-if="item.metadata && item.metadata.title" class="title">{{item.metadata.title}}</div>
                          <div v-if="item.metadata && item.metadata.artist" class="artist">{{item.metadata.artist}}</div>
                        </template>
                        <template v-else>
                          <div class="title">{{item.name}}</div>
                        </template>
                      </div>
                    </div>

                    <div :style="{'backgroundColor': item._edit.backgroundColor}" class="media-row-background"></div>

                    <template v-if="projectFrameStatus === projectFrameStatusOptions.EDIT_FRAME">
                      <!-- Row Actions -->
                      <div  class="media-actions">
                        <!-- Duplicate Row -->
                        <el-button :class="['cstm-icon-btn-medium copy', {'hidden': false,'is-selected': false}]"
                          @click="handleMediaRowClick(mediaRowActions.duplicateRow, item, indx, $event)">
                        </el-button>

                        <!-- Delete Row -->
                        <el-button :class="['cstm-icon-btn-medium remove', {'is-parent-row-selected': false,
                          'is-selected': false,
                          'hover-all-delete-icon': hoverAllDeleteIcon}]"
                          @click="handleMediaRowClick(mediaRowActions.deleteRow, item, indx, $event)">
                        </el-button>
                      </div>
                    </template>

                    <template v-if="projectFrameStatus === projectFrameStatusOptions.PLAY_FRAME">
                      <!-- Row Actions -->
                      <div v-if="projectPreview" class="media-preview-actions">
                      </div>
                    </template>

                    <div class="media-row-item-cover"
                      @click="handleMediaRowClick(mediaRowActions.rowSelected, item, indx, $event)">
                    </div>
                  </div>
                </template>
              </draggable>
            </template>

            <!--Add new audio-->
            <template v-if="projectFrameStatus === projectFrameStatusOptions.EDIT_FRAME">
              <el-button v-if="true" @click="addAudioIconClick" class="cstm-icon-btn-medium add add-new-audio"></el-button>
            </template>
          </div>
        </div>
      </el-main>

      <el-aside class="cpl-aside">
        <div class="content hide-scrollbar">
          <div v-if="projectAudioPlaylist.hasOwnProperty('_edit')" class="project-action-options">
            <!-- Settings Icon to show settings menu items -->
            <el-tooltip
              :popper-class="'custom-tooltip-popper capitalize-text'"
              :show-arrow="false"
              effect="light"
              :content="$t('label.edit')"
              :index="'audioProjectTabIconTooltipEdit'"
              placement="bottom"
              class="item">
              <el-button
                @click="handleEditTemplateMenuItemsTabIcon(menuItemTabIds.settings)"
                :class="['cstm-icon-btn-medium', 'pencil_circle_grey', {'is-selected': projectFrameStatus === projectFrameStatusOptions.EDIT_FRAME && selectedEditFrameTab === menuItemTabIds.settings}]">
              </el-button>
            </el-tooltip>

            <!-- Edit Project Schedule -->
            <el-tooltip
              :popper-class="'custom-tooltip-popper capitalize-text'"
              :show-arrow="false"
              effect="light"
              :content="$t('label.preview')"
              :index="'audioProjectTabIconTooltipPreview'"
              placement="bottom"
              class="item">
              <el-button
                :disabled="menuItemInProgressRequests.length > 0"
                :class="['cstm-icon-btn-medium', 'play_circle_grey', {'is-selected': projectFrameStatus === projectFrameStatusOptions.PLAY_FRAME && projectAudioPlaylistAction === CONST.PROJECT_EDIT_AUDIO_PLAYLIST}]"
                @click="handleEditTemplateMenuItemsTabIcon(menuItemTabIds.projectSchedule)">
              </el-button>
            </el-tooltip>
          </div>

          <!-- Edit Template Section -->
          <template v-if="projectFrameStatus === projectFrameStatusOptions.EDIT_FRAME && projectAudioPlaylist.hasOwnProperty('_edit')">
            <div id="editProjectAudioPlaylistSection" class="hide-scrollbar">
              <project-audio-menu ref="projectAudioSettings"
                :projectTemplateActionProp="projectAudioPlaylistAction"
                :projectTemplateProp="projectAudioPlaylist"
                :tagsSummaryForSuggestionsProp="tagsSummaryForSuggestions"
                @project-audio-menu-change="handleProjectAudioMenuChange($event)">
              </project-audio-menu>

              <!-- Submit Button -->
              <div ref="submitButtonWrapper" class="submit-btn-wrapper">
                <el-button :disabled="menuItemInProgressRequests.length > 0"
                  @click="handleProjectSubmitButtonClick('submitProject')"
                  class="cstm-btn-grey width-125 as-next-btn white-background">
                  {{$t('label.next')}}
                </el-button>
              </div>
            </div>
          </template>

          <!-- Edit Project Media Details -->
          <template v-if="(projectFrameStatus === projectFrameStatusOptions.PLAY_FRAME) && (projectAudioPlaylistAction === CONST.PROJECT_EDIT_AUDIO_PLAYLIST)">
            <div id="editMediaSection" class="hide-scrollbar">
              <media-details-menu v-if="projectMediaDetails !== null && userSchedulesDoneFetching"
                ref="projectDetailsMenu"
                :accessorComponentProp="'projectPage'"
                :mediaPropertiesToHideProp="['delete']"
                :mediaSelectionProp="[projectMediaDetails]"
                :userSchedulesProp="userSchedules"
                :isMediaAlertTypeProp="projectMediaDetails.alert"
                :tagsSummaryProp="tagsSummaryForSuggestions"
                @media-menu-change="menuMediaDetailsOnChange($event)">
              </media-details-menu>

              <!-- Submit Button -->
              <div ref="submitButtonWrapper" v-if="(userSchedulesDoneFetching)" class="submit-btn-wrapper">
                <el-button @click="handleProjectSubmitButtonClick('submitMedia')" class="cstm-btn-gradient width-125">
                  <template v-if="projectMediaDetails.alertSubmitBtn">
                    <template v-if="projectMediaDetails.alertSubmitBtn === 'activate'"> {{$t('label.activate')}} </template>
                    <template v-else-if="projectMediaDetails.alertSubmitBtn === 'reactivate'"> {{$t('label.reactivate')}} </template>
                    <template v-else> {{$t('label.ok')}} </template>
                  </template>
                  <template v-else>
                    {{$t('label.ok')}}
                  </template>
                </el-button>
              </div>
            </div>
          </template>
        </div>
      </el-aside>
    </el-container>

    <!-- Media List Dialog -->
    <div class="cstm-modal-media-list">
      <el-dialog
        v-if="mediaListDialog.isVisible"
        id="mediaDialogInCeateAudioPage"
        :z-index="999"
        :model-value="mediaListDialog.isVisible"
        :close-on-click-modal="false"
        :class="{'cstm-modal-media-list': true, 'vertical': (projectOrientation === 'vertical')}"
        :modal="false"
        @close="handleDialogClose">

        <media-list
          :accessorComponentProp="'createProjectAudio'"
          :defaultMediaTypeFilterProp="mediaListDialog.filterType"
          :mediaSelectionProp="mediaListDialog.mediaSelection"
          :mediaTypeOptionsProp="mediaListDialog.filterTypeOptions"
          :isMediaListVisibleProp="mediaListDialog.isVisible"
          :isMultipleUploadProp="true"
          @media-list-change="handleMediaListChange($event)">
        </media-list>
      </el-dialog>
    </div>
  </div>
</template>

<script src="./project-audio.js"></script>
<style lang="scss" src="./project-audio.scss"></style>
